/**
 * YouTube thumbnail for blocks/product-videos.liquid: swaps in the player
 * (and starts it) when clicked, so the page doesn't load YouTube until needed.
 */
class PaccVideoFacade extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', this.#play, { once: true });
  }

  #play = () => {
    const iframe = document.createElement('iframe');
    iframe.src = this.dataset.src ?? '';
    iframe.title = this.dataset.title ?? '';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    this.replaceChildren(iframe);
    iframe.focus();
  };
}

if (!customElements.get('pacc-video-facade')) customElements.define('pacc-video-facade', PaccVideoFacade);
